import { isEqual } from "@s-libs/micro-dash";
import { useEffect, useState, useRef } from "react";
import { Transaction } from "@tiptap/pm/state";
import { Editor } from "@tiptap/core";

import { dynamicDataPluginKey, IDynamicData } from "./DataProvider";

export const isShallowEqual = (a: any, b: any) => {
  if (!isEqual(Object.keys(a), Object.keys(b))) {
    return false;
  }
  const hasMismatchedKeys = Object.keys(a).find((key: string) => {
    return a[key] !== b[key];
  });
  return !hasMismatchedKeys;
};
export const useDynamicDataProvider = (editor: Editor): IDynamicData => {
  const [dynamicData, setDynamicData] = useState(
    dynamicDataPluginKey.getState(editor?.state || {}),
  );

  const dynamicDataRef = useRef(dynamicData);

  // Update the ref when dynamicData changes to ensure that handleUpdate always has access to the up-to-date
  // object.
  useEffect(() => {
    dynamicDataRef.current = dynamicData;
  }, [dynamicData]);

  useEffect(() => {
    if (!editor) return;

    const handleUpdate = ({ transaction }: { transaction: Transaction }) => {
      const meta = transaction.getMeta(dynamicDataPluginKey);
      if (meta) {
        const newDynamicData = meta.dynamicData;
        if (
          newDynamicData &&
          newDynamicData !== dynamicDataRef.current &&
          !isShallowEqual(newDynamicData, dynamicDataRef.current)
        ) {
          setDynamicData(newDynamicData);
        }
      }
    };

    // Subscribe to all transactions!
    editor.on("transaction", handleUpdate);

    return () => {
      // Clean up to prevent memory leaks.
      editor.off("transaction", handleUpdate);
    };
  }, [editor]);

  return dynamicData;
};
